import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "circle-question_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 5a2 2 0 0 0-2 2v1H8V9a4 4 0 0 1 4-4h.252A3.748 3.748 0 0 1 16 8.748c0 1.067-.424 2.09-1.178 2.844L13.414 13A1.414 1.414 0 0 0 13 14h-2c0-.905.36-1.774 1-2.414l1.408-1.408c.379-.38.592-.894.592-1.43C14 7.783 13.217 7 12.252 7H12Zm0 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }